/**
 * The person page's binding of the shared detail-page surface.
 *
 * Unlike the team and department pages, this one HAS a detail pane: pressing
 * a matter or a task on the canvas opens it in place. So it binds the full
 * hook — panes + selection — and names its selection kind.
 */

import useDetailSurface, {
  UseDetailSurfaceOptions,
  UseDetailSurfaceResult,
} from '../../../shared/surface/useDetailSurface';
import {
  PERSON_SURFACE,
  PERSON_TABS,
  PersonPanelId,
  PersonSelectionKind,
  PersonTab,
} from './layout';

export { PERSON_SURFACE, PERSON_TABS };
export type { PersonPanelId, PersonSelectionKind, PersonTab };

export type PersonWorkspace = UseDetailSurfaceResult<
  PersonPanelId,
  PersonSelectionKind,
  never,
  PersonTab
>;

/** Keyed by the person's uuid — each remembers their own arrangement. */
export const usePersonWorkspace = (
  personId: string,
  options: Omit<UseDetailSurfaceOptions<PersonTab>, 'entityId'> = {}
): PersonWorkspace =>
  useDetailSurface<PersonPanelId, PersonSelectionKind, never, PersonTab>(PERSON_SURFACE, {
    ...options,
    entityId: personId,
  });
